<div class="deats-container">
  <section class="flex justify-between items-center bg-white border-2 border-b-indigo-800">
    <div matDialogTitle>House details</div>

    <button type="button" mat-icon-button matDialogClose (click)="closeDialog()" title="Close dialog">
      <mat-icon fontIcon="close" aria-label="close icon"></mat-icon>
  </button>
</section>
  <div matDialogContent>
    <mat-tab-group mat-stretch-tabs>
      <mat-tab label="Maps">Content 1</mat-tab>
      <mat-tab label="Photos">

        <mat-grid-list cols="2" rowHeight="2:1">
          <mat-grid-tile>
            <img class="img" mat-card-image src="assets/images/r2.png" alt="Photo of the appropriate room" />
          </mat-grid-tile>
          <mat-grid-tile>
            <img class="img" mat-card-image src="assets/images/yes.jpg" alt="Photo of the appropriate room" />
          </mat-grid-tile>
          <mat-grid-tile>
            <img class="img" mat-card-image src="assets/images/r2.png" alt="Photo of the appropriate room" />
          </mat-grid-tile>
          <mat-grid-tile>
            <img class="img" mat-card-image src="assets/images/k2.png" alt="Photo of the appropriate room" />
          </mat-grid-tile>
        </mat-grid-list>
         
      </mat-tab>
      <mat-tab label="Details">Content 3</mat-tab>
    </mat-tab-group>
  </div>
</div>
<!-- https://css-tricks.com/cool-little-css-grid-tricks-for-your-blog/ -->
<!-- https://blog.angular-university.io/angular-host-context/ -->
<!-- 
    why we can't use google maps anyhow https://developers.google.com/maps/gmp-get-started
    
    we'll use https://developers.google.com/maps/billing/gmp-billing?authuser=1#embed

    specifically https://developers.google.com/maps/documentation/embed/guide?authuser=1#place_mode

    tutorial https://timdeschryver.dev/blog/google-maps-as-an-angular-component
    https://dev.to/devpato/setup-google-map-in-angular-app-the-pro-way-3m9p

-->
